import React, { useEffect, useState } from 'react'
import { Backdrop, Box, Button, Card, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, Divider, FormControlLabel, FormGroup, Typography } from '@mui/material'
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { useDispatch } from 'react-redux';
import { setActiveScreens } from 'src/redux/actions/Screen';
import toast from 'react-hot-toast';

const ManageInactiveScreensDialog = ({
    open,
    setOpen,
    screens,
    availableScreens,
    setDisableScreensStatusSet
}) => {
    const [screensSettings, setScreenSettings] = useState([])
    const [screenStatus, setScreenStatus] = useState([])
    const [isSummary, setIsSummary] = useState(false)
    useEffect(() => {
        setScreenSettings([...screens])
        setScreenStatus([...screens.filter(s => !s.isDisabled).map(s => s._id)])
    }, [screens])
    const [isLoading, setIsLoading] = useState(false)

    const dispatch = useDispatch()

    const setScreensStatus = (id, status) => {
        console.log(screenStatus)
        if (status) {
            // if (screensSettings.length-screenStatus.length < availableScreens) {
                setScreenStatus((prev) => [...prev, id])
            // }else {
            //     setScreenStatus((prev) => [id, ...prev.slice(null, -1)])
            // }
        }else {
            setScreenStatus((prev) => [...prev.filter(id => id !== id)])
        }
        // console.log([3,54,2,4,6,7,,1,4,562,52].sort((a, b) => b-a))
        // let newSettings = [{...screens.find(s => s._id == id), isDisabled: status, updatedAt: new Date().getTime()}, ...screens.filter(s => s._id !== id).map((s, index) => {return {...s, isDisabled: true, updatedAt: new Date().getTime()+index}}).sort((a, b) => b.updatedAt - a.updatedAt)]
        // console.log(newSettings)
        // newSettings = newSettings.map((x, index) => {return {...x, isDisabled: index >= availableScreens}})
        // setScreenSettings(newSettings)
    }

    const closeModal = () => {
        setScreenSettings([])
        setScreenStatus([])
        setIsSummary(false)
        setIsLoading(false)
        setOpen(false)
    }

    const handleSetScreenStatuses = async () => {
        setIsLoading(true)
        const res = await dispatch(setActiveScreens(screenStatus))
        if (res) {
            toast.success("Successfully changed screen's statuses")
            setDisableScreensStatusSet(true)
        }else {
            toast.error("Error #E1")
        }
        closeModal()
        setIsLoading(false)
    }

  return (
    <Dialog
        open={open}
        onClose={closeModal}
        fullWidth
        maxWidth="sm"
    >
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 100, position: 'absolute' })}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
        <DialogContent>
            <DialogContentText>Manage inactive screens</DialogContentText>
            {isSummary ? (
                <>
                    {screenStatus.length > 0 && (
                        <>
                            <Typography mt={2} variant='subtitle1'>Check your settings</Typography>
                            <Card variant='outlined' sx={{
                                border: "1px solid #0B815A",
                                mt: 3
                            }}>
                                <Typography sx={{
                                    backgroundColor: "#0B815A",
                                    p: 2
                                }}>Active</Typography>
                                <ul>
                                    {screenStatus.map(s => {return <li>{screensSettings.find(x => x._id == s)?.name}</li>})}
                                </ul>
                            </Card>                        
                        </>
                    )}
                    {screensSettings.filter(s => !screenStatus.find(y => y == s._id)).length > 0 && (
                        <Card variant='outlined' sx={{
                            border: "1px solid #F04438",
                            mt: 3
                        }}>
                            <Typography sx={{
                                backgroundColor: "#F04438",
                                p: 2
                            }}>Inactive</Typography>
                            <ul>
                                {screensSettings.filter(s => !screenStatus.find(y => y == s._id)).map(s => {return <li>{s?.name}</li>})}
                            </ul>
                        </Card>                    
                    )}
                </>
            ) : (
                <>
                    <Typography mt={2}>Here  you can specify which screen should be visible</Typography>
                    <Typography variant="subtitle1">Total screens: <b>{screens?.length}</b></Typography>
                    <Typography variant="subtitle1" color="success.main">Available screens: <b>{availableScreens}</b></Typography>
                    <Typography variant="subtitle1" color="success.warning">{`Inactive (locked) screens:`} <b>{screens?.filter(s => s.isDisabled)?.length}</b></Typography>
                    <FormGroup sx={{
                        mt: 3
                    }}>
                        {screensSettings.map((sc, index) => {
                            return (
                                <Box>
                                    <FormControlLabel disabled={!screenStatus.includes(sc._id) && (screenStatus.length == availableScreens)} key={index} control={<Checkbox checked={screenStatus.includes(sc._id)} onChange={(e) => setScreensStatus(sc._id, e.target.checked)} />} label={<span style={{color: screenStatus.includes(sc._id) ? "#0B815A" : "#F04438"}}>{sc.name}</span>} />
                                    <Divider/>
                                </Box>
                            )
                        })}                
                    </FormGroup>                 
                </>
            )}           
        </DialogContent>
        <DialogActions>
            {isSummary ? (
                <Button variant="outlined" color="warning" onClick={() => setIsSummary(false)}>Back</Button>
            ) : (
                <Button variant="outlined" color="error" onClick={() => setOpen(false)}>Cancel</Button>
            )}
            {isSummary ? (
                <Button variant="contained" color="success" onClick={handleSetScreenStatuses}>Confirm & save</Button>
            ) : (
                <Button variant="contained" color="success" onClick={() => {setIsSummary(true)}}>Next</Button>
            )}
        </DialogActions>
    </Dialog>
  )
}

export default ManageInactiveScreensDialog
